<template>
<div class="ml-3 service-book-dashboard">
  <div class="row no-gutters py-2 mb-3 ml-3">
    <div class="col-md-10 col-sm-12" >
      <h4 class="atlhr-dashboard-title mt-10">
        My <span class="black-title">Approval</span>
        <span>
                    <a v-bind:href="$api_url">Dashboard</a>  / Leave and Attendance / My Approval
                </span>
      </h4>
    </div>
  </div>

  <div v-if="loaded" class="mt-4 employee-tab leave-attendance-dashboard employee-investment-wrapper">
    <b-tabs pills content-class="" nav-class=" pr-2 m-2 leave-attendance-dashboard-tab roster-approval-front-tab"
        nav-wrapper-class="col-md-12 custom-tab-nav custom-margin ml-auto pl-0 bg-white">
          <b-tab lazy>
            <template v-slot:title>
              <span class="nav-text font-weight-bolder">Pending Approval</span>
            </template>
            <div class="tab-item-wrapper">
                <div class="clearfix leave-log mt-3">
                  <div class="employee-investment-wrapper">
                    <div class="" >
                      <div class="row no-gutters mb-3">
                        <div class="leave-log-wrapper w-100">
                          <roster-waiting-approval></roster-waiting-approval>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </b-tab>
          <b-tab lazy>
            <template v-slot:title>
              <span class="nav-text font-weight-bolder">Leave</span>
            </template>
            <div class="tab-item-wrapper">
              <div v-if="approver[0]" class="clearfix leave-log mt-3">
                <div class="px-3 d-flex justify-content-between align-items-center">
                  <div class="company-form-box-title">
                    Leave Log
                  </div>
                  <b-button @click="$bvModal.show('bv-modal-add-leave-approver')">Apply Leave</b-button>
                </div>
                <div class="px-3 employee-investment-wrapper">
                  <roster-leave-list-approver ref="leaveList"></roster-leave-list-approver>
                </div>
              </div>
              <div v-else class="clearfix leave-log mt-3 p-5 text-center bg-white rounded shadow-sm">
                <div class="d-inline-flex align-items-center justify-content-center bg-light text-danger rounded-circle mb-3" style="width: 60px; height: 60px;">
                  <i class="fa fa-lock fa-2x"></i>
                </div>
                <h5 class="font-weight-bold text-dark mb-2">Feature Not Available</h5>
                <p class="text-muted mb-0">You are not registered as an approver for the Leave module.</p>
              </div>
            </div>
          </b-tab>
          <b-tab lazy>
            <template v-slot:title>
              <span class="nav-text font-weight-bolder">Attendance</span>
            </template>
            <div class="tab-item-wrapper">
              <div v-if="approver[1] || approver[2]" class="clearfix leave-log mt-3">
                <div class="p-3 employee-investment-wrapper">
                  <roster-employees-attendance-approver></roster-employees-attendance-approver>
                </div>
              </div>
              <div v-else class="clearfix leave-log mt-3 p-5 text-center bg-white rounded shadow-sm">
                <div class="d-inline-flex align-items-center justify-content-center bg-light text-danger rounded-circle mb-3" style="width: 60px; height: 60px;">
                  <i class="fa fa-lock fa-2x"></i>
                </div>
                <h5 class="font-weight-bold text-dark mb-2">Feature Not Available</h5>
                <p class="text-muted mb-0">You are not registered as an approver for the Attendance module.</p>
              </div>
            </div>
          </b-tab>
      </b-tabs>
    </div>

    <b-modal dialog-class="w-1000" id="bv-modal-add-leave-approver" size="xl" scrollable  hide-footer title="Leave Details" @hidden="resetSubordinateContext">
      <roster-search-employees v-if="employee_id == 0"  :flg="1" :all="1" v-on:childToParent="setEmployee" :front="1"></roster-search-employees>
      <div v-if="employee_id > 0 && employeeInfo" class="employee-info-card p-3 mb-4 rounded-lg shadow-sm border-0 position-relative overflow-hidden" style="background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <b-avatar  variant="white" :src="employeeInfo.pic ? ($api_url + '/avatar/' + employeeInfo.company_id + '/' + employeeInfo.pic) : ''" size="4.5rem" class="mr-3 shadow border"></b-avatar>
            <div>
              <h5 class="mb-1 font-weight-bold text-dark" style="letter-spacing: -0.2px;">{{ employeeInfo.name }}</h5>
              <div class="d-flex flex-wrap text-muted small mt-1">
                <span class="mr-3 mb-1">Code: {{ employeeInfo.employee_code }}</span>
                <span class="mr-3 mb-1"><strong>Department:</strong> {{ employeeInfo.department }}</span>
                <span class="mb-1"><strong>Designation:</strong> {{ employeeInfo.jobposition }}</span>
              </div>
            </div>
          </div>
          <b-button @click="resetSubordinateContext">
             Change Employee
          </b-button>
        </div>
      </div>
      <roster-ess-employee-leave-details v-if="employee_id > 0"  :editflg="0" v-on:childToParent="getLeavesNew" @hideModal="hideModal"></roster-ess-employee-leave-details>
    </b-modal>
</div>
</template>

<script>
  export default {
    data(){
      return {
        approver: [false, false, false],
        employee_id: 0,
        employeeInfo: null,
        loaded: false,
      }
    },
    methods: {
      checkIsApprover: function()
      {
        if(!this.checkNet()) return false;

        axios.get(this.$api_url+'/front/leave-attendance/approver/check').then(function(response){
          this.approver = response.data;
          this.loaded = true;
        }.bind(this)).catch(function (error){
          this.serverError(error);
          this.loaded = true;
        }.bind(this));

      },
      setEmployee: function(x)
      {
        this.employee_id = x.employee_id;
        this.employeeInfo = x.employeeInfo;
      },
      getLeavesNew: function()
      {
        if (this.$refs.leaveList) {
          this.$refs.leaveList.getLeaves();
        }
      },
      resetSubordinateContext: function()
      {
        this.employee_id = 0;
        this.employeeInfo = null;
        if (!this.checkNet()) return false;
        axios.post(this.$api_url + '/front/leave-attendance/manager/unset').catch(error => {
          this.serverError(error);
        });
      },
      hideModal(){
        this.resetSubordinateContext();
        this.$bvModal.hide('bv-modal-add-leave-approver');
      }
    },
    created() {
      this.checkIsApprover();
    }
  }
</script>